import { Spinner } from '@chakra-ui/react';
import React from 'react';

export const Loader = (top) => {
  const height = top.top || 300;
  return <Spinner size='xl' marginTop={height} color={'#6C56FB'} />;
};
